// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 593) return "static/chunks/framework-269de3147eed741d.js";
	if (chunkId === 410) return "static/chunks/410-341e4c31ac5b9cc6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"192":"9e9dcdc0998979c7","615":"bad8505b7b4bd9ce","621":"50b613be91ba73ed","656":"86326a186605c424","674":"81c36a4c1ca80e4b","685":"3cb1aafd206e69ee","843":"2d069a2e09e5a3c1","906":"cda1a055fd2d0fd8","937":"4e09d8431b885992","996":"6096661fcd801602"}[chunkId] + ".js";
};